module.exports = __webpack_public_path__ + "img/login_bg.ded1e44b.svg";